import React from "react";

/**
 * Napoli — branded skeleton blocks. Used in place of spinners while data
 * is in-flight. The shimmer color is tuned to the cream/marble surface.
 */
export const SkeletonBlock = ({ className = "", ...rest }) => (
  <div
    aria-hidden
    className={[
      "animate-pulse bg-napoli-cream-warm/70 border border-napoli-gold/15",
      className,
    ].join(" ")}
    {...rest}
  />
);

export const SkeletonText = ({ width = "w-32", className = "" }) => (
  <SkeletonBlock className={`h-3 ${width} ${className}`} />
);

export default SkeletonBlock;
